import { AxiosResponse } from 'axios'
import { http } from '../../../../../src/utils'

export interface EInvoiceItem {
  productName: string
  productDesc: string
  hsnCode: number
  isService: boolean
  unitPrice: number
  quantity: number
  qtyUnit: string
  taxableAmount: number
  amount?: number
  discount?: number
  sgstRate: number
  cgstRate: number
  igstRate: number
  cessRate: number
}

export interface EInvoiceAddress {
  address1?: string
  address2?: string
  place?: string
  pincode?: string
  state?: string
}

export interface EInvoiceGstParty {
  name?: string
  gstin?: string
  address?: EInvoiceAddress
}

interface EInvoiceInfoItemRaw {
  productName: string
  productDesc: string
  hsnCode: number
  isService: string
  unitPrice: number
  quantity: number
  qtyUnit: string
  taxableAmount: number
  amount?: number
  discount?: number
  sgstRate: number
  cgstRate: number
  igstRate: number
  cessRate: number
}

export interface IrnValDetailsResponse {
  assVal?: number
  cgstVal?: number
  sgstVal?: number
  igstVal?: number
  cesVal?: number
  stCesVal?: number
  discount?: number
  othChrg?: number
  rndOffAmt?: number
  totInvVal?: number
}

export interface EInvoiceInfoResponse {
  invoiceNumber?: string
  docType?: string
  invoiceDate?: string | number
  supplyType?: string
  reverseCharge?: boolean
  igstOnIntra?: boolean
  billFrom?: EInvoiceGstParty
  billTo?: EInvoiceGstParty
  dispatchFrom?: EInvoiceAddress
  shipTo?: EInvoiceAddress
  shipToGstin?: string
  itemList?: EInvoiceInfoItemRaw[]
  valDetails?: IrnValDetailsResponse
}

export function getEInvoiceInfo(id: number) {
  return http
    .get(`/einvoice/pvt/${id}/einvoice_info`)
    .then((response: AxiosResponse) => response)
}

export function generateEInvoice(eInvoiceId: number, request: object) {
  return http
    .post(
      `${process.env.EWAY_API_BASE_URL}einvoice/generate/${eInvoiceId}`,
      request
    )
    .then((response: AxiosResponse) => response)
}

export function viewEInvoicePDF(irn: string) {
  return http
    .get(
      `${
        process.env.EWAY_API_BASE_URL
      }einvoice/view_pdf?irn=${encodeURIComponent(irn)}`
    )
    .then((response: AxiosResponse) => response)
}

export interface CancelEInvoiceRequest {
  Irn: string
  CnlRsn: string
  CnlRem: string
}

export function cancelEInvoice(request: CancelEInvoiceRequest) {
  return http
    .post(`${process.env.EWAY_API_BASE_URL}einvoice/cancel`, request)
    .then((response: AxiosResponse) => response)
}
